import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Toast {
  id: number;
  message: string;
  durationSeconds?: number;
}

type AddToastPayload = string | {
  message: string;
  durationSeconds?: number;
};

interface ToastState {
  toasts: Toast[];
}

const initialState: ToastState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<AddToastPayload>) => {
      const { message, durationSeconds } = typeof action.payload === "string"
        ? { message: action.payload, durationSeconds: undefined }
        : action.payload;

      state.toasts.push({
        id: Date.now(),
        message,
        durationSeconds,
      });
    },
    removeToast: (state, action: PayloadAction<number>) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;